<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <b-card style="border:none; cursor:pointer;" class="mb-2"
            @mouseover="hover_in('sc')" @mouseout="hover_out('sc')"
            @click="$router.push('/SupplyCode')">
            <b-icon icon="card-checklist" font-scale="3" variant="dark" class="card-icon" id="sc"></b-icon>
            <br><b-button variant="transparent" class="link">Supply Code</b-button>
          </b-card>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/distribution_code.pdf" id="dc1" hidden>
          <b-card style="border:none" class="mb-2" @mouseover="hover_in('dc')" @mouseout="hover_out('dc')"
            @click="showDoc('dc1')">
            <b-icon icon="layout-text-sidebar-reverse" font-scale="3" variant="dark" class="card-icon" id="dc"></b-icon>
            <br><b-button variant="transparent" class="link textAlign15px">Distribution Code</b-button>
          </b-card>


        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/KnowYourTariff">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('kyt')"
              @mouseout="hover_out('kyt')">
              <b-icon icon="graph-up" font-scale="3" variant="dark" class="card-icon" id="kyt"></b-icon>
              <br><b-button variant="transparent" class="link">Know Your Tariff</b-button>
            </b-card>
          </router-link>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/TariffOrder">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2 " @mouseover="hover_in('to')"
              @mouseout="hover_out('to')">
              <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="to"></b-icon>
              <br><b-button variant="transparent" class="link">Tariff Order</b-button>
            </b-card>
          </router-link>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/TariffFiling">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('tfp')"
              @mouseout="hover_out('tfp')">
              <b-icon icon="files" font-scale="3" variant="dark" class="card-icon" id="tfp"></b-icon>
              <br><b-button variant="transparent" class="link">Tariff Filing and Petition</b-button>
            </b-card>
          </router-link>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/electricity_act_2003.pdf" id="ea1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('ea')"
            @mouseout="hover_out('ea')" @click="showDoc('ea1')">
            <b-icon icon="file-earmark-text" font-scale="3" variant="dark" class="card-icon" id="ea"></b-icon>
            <br><b-button variant="transparent" class="link">Electricity Act, 2003</b-button>
          </b-card>

        </b-col>
      </b-row>

      <b-row>


        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/RTI_act_2005.pdf" id="roi1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2 " @mouseover="hover_in('roi')"
            @mouseout="hover_out('roi')" @click="showDoc('roi1')">
            <b-icon icon="file-check" font-scale="3" variant="dark" class="card-icon" id="roi"></b-icon>
            <br><b-button variant="transparent" class="link textAlign15px">Right to Information Act, 2005 </b-button>
          </b-card>
          </a>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/consumer_grievances_redressal_guidelines.pdf" id="cg1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('cg')"
            @mouseout="hover_out('cg')" @click="showDoc('cg1')">
            <b-icon icon="briefcase" font-scale="3" variant="dark" class="card-icon" id="cg"></b-icon>
            <br><b-button variant="transparent" class="link">Consumer Grievance Redressal Guidlines</b-button>
          </b-card>

        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">

          <a href="https://powermin.gov.in/sites/default/files/webform/notices/Tariff_Policy-Resolution_Dated_28012016.pdf"
            target="_blank">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2 " @mouseover="hover_in('tp')"
              @mouseout="hover_out('tp')">
              <b-icon icon="list-ul" font-scale="3" variant="dark" class="card-icon" id="tp"></b-icon>
              <br><b-button variant="transparent" class="link">Tariff Policy</b-button>
            </b-card>
          </a>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <a href="https://powermin.gov.in/en/content/national-electricity-policy" target="_blank">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2 " @mouseover="hover_in('nep')"
              @mouseout="hover_out('nep')">
              <b-icon icon="file-richtext" font-scale="3" variant="dark" class="card-icon" id="nep"></b-icon>
              <br>
              <b-button variant="transparent" class="link textAlign15px">National Electricity Policy</b-button>
            </b-card>
          </a>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/RE_policy.pdf" id="rep1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2 " @mouseover="hover_in('rep')"
            @mouseout="hover_out('rep')" @click="showDoc('rep1')">
            <b-icon icon="file-ruled" font-scale="3" variant="dark" class="card-icon" id="rep"></b-icon>
            <br><b-button variant="transparent" class="link textAlign20px">Rural Electrification Policy</b-button>
          </b-card>

        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/assam_solar_energy_policy_2017.pdf" id="solar1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('solar')"
            @mouseout="hover_out('solar')" @click="showDoc('solar1')">
            <b-icon icon="brightness-high" font-scale="3" variant="dark" class="card-icon" id="solar"></b-icon>
            <br><b-button variant="transparent" class="link" id="card-button">Assam Solar Energy Policy, 2017</b-button>
          </b-card>

        </b-col>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/assam_electricity_duty_amendment_act_2018.pdf" id="ed1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('ed')"
            @mouseout="hover_out('ed')" @click="showDoc('ed1')">
            <b-icon icon="card-text" font-scale="3" variant="dark" class="card-icon" id="ed"></b-icon>
            <br><b-button variant="transparent" class="link textAlign15px" id="card-button"> Assam Electricity Duty
              (Amendment) Act, 2018
            </b-button>
          </b-card>

        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <!-- <input value="/docs/acts_and_rules/fpppa_regulation.zip" id="reg1" hidden> -->
          <router-link to="/fpppa">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('reg')"
              @mouseout="hover_out('reg')">
              <b-icon icon="file-earmark-zip" font-scale="3" variant="dark" class="card-icon" id="reg"></b-icon>
              <br><b-button variant="transparent" class="link textAlign10px">FPPPA Regulation</b-button>
            </b-card>
          </router-link>
        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/standards_of_performance.pdf" id="sop1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('sop')"
            @mouseout="hover_out('sop')" @click="showDoc('sop1')">
            <b-icon icon="clipboard-data" font-scale="3" variant="dark" class="card-icon" id="sop"></b-icon>
            <br><b-button variant="transparent" class="link">Standard of Performance Regulations, 2004</b-button>
          </b-card>

        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/record_retention_manual.pdf" id="rrm1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2 card-icon" @mouseover="hover_in('rrm')"
            @mouseout="hover_out('rrm')" @click="showDoc('rrm1')">
            <b-icon icon="card-heading" font-scale="3" variant="dark" class="card-icon" id="rrm"></b-icon>
            <br><b-button variant="transparent" class="link textAlign10px">Record Retention Manual</b-button>
          </b-card>

        </b-col>

        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/assam_electricity_works_of_licensees_rules.pdf" id="rules1" hidden>

          <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('rules')"
            @mouseout="hover_out('rules')" @click="showDoc('rules1')">
            <b-icon icon="book" font-scale="3" variant="dark" class="card-icon" id="rules"></b-icon>
            <br><b-button variant="transparent" class="link textAlign10px">Assam Electricity Works of Licensees Rules
              2019</b-button>
          </b-card>

        </b-col>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/general_condition_of_supply_erection.pdf" id="se1" hidden>
          <b-card title="" style="max-width: 20rem;border:none" class="mb-2" @mouseover="hover_in('se')"
            @mouseout="hover_out('se')" @click="showDoc('se1')">
            <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="se"></b-icon>
            <br><b-button variant="transparent" class="link">General Condition of Supply and Erection</b-button>
          </b-card>
        </b-col>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/BeeEnergyReport">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('bee')"
              @mouseout="hover_out('bee')">
              <b-icon icon="bar-chart" font-scale="3" variant="dark" class="card-icon" id="bee"></b-icon>
              <br>
              <b-button variant="transparent" class="link">BEE Energy Accounting & Audit Reports</b-button>
            </b-card>
          </router-link>
        </b-col>


        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/csr_apdcl.pdf" id="csr1" hidden>
          <b-card title="" style="max-width: 20rem;border:none" class="mb-2" @mouseover="hover_in('csr')"
            @mouseout="hover_out('csr')" @click="showDoc('csr1')">
            <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="csr"></b-icon>
            <br><b-button variant="transparent" class="link">Corporate Social Responsibility (CSR) Policy</b-button>
          </b-card>
        </b-col>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/Vigil_Mechanism_Policy.pdf" id="vgl1" hidden>
          <b-card title="" style="max-width: 20rem;border:none" class="mb-2" @mouseover="hover_in('vgl')"
            @mouseout="hover_out('vgl')" @click="showDoc('vgl1')">
            <b-icon icon="file-check" font-scale="3" variant="dark" class="card-icon" id="vgl"></b-icon>
            <br><b-button variant="transparent" class="link">Vigil Mechanism Policy</b-button>
          </b-card>
        </b-col>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/POSH_Act_2013.pdf" id="pact1" hidden>
          <b-card style="border:none;" class="mb-2 " @mouseover="hover_in('pact')" @mouseout="hover_out('pact')"
            @click="showDoc('pact1')">
            <b-icon icon="card-checklist" font-scale="3" variant="dark" class="card-icon" id="pact"></b-icon>
            <br><b-button variant="transparent" class="link">POSH Act</b-button>
          </b-card>

        </b-col>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/PoshPolicy">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2 " @mouseover="hover_in('ic')"
              @mouseout="hover_out('ic')">
              <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="ic"></b-icon>
              <br><b-button variant="transparent" class="link">Information on Internal Committee APDCL</b-button>
            </b-card>
          </router-link>
        </b-col>
        <!---<b-col col cols="4" sm="2" md="2" lg="2">
      <input value="/docs/acts_and_rules/Assam_ ICEP_2025.pdf" id="cleanEnergy1" hidden>
        <b-card
        title=""
        style="max-width: 20rem;border:none"
        class="mb-2"
        @mouseover="hover_in('cleanEnergy')" @mouseout="hover_out('cleanEnergy')" @click="showDoc('cleanEnergy1')"
        >
        <b-icon icon="book" font-scale="3" variant="dark" class="card-icon" id="cleanEnergy" ></b-icon>
        <br><b-button variant="transparent" class="link" >Assam Integrated Clean Energy Policy- 2025</b-button>
      </b-card>
    </b-col>-->
        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/AssamSolarPowerGenerationPromotionPolicy2025.pdf"
            id="SolarPowergenerationPolicy1" hidden>
          <b-card title="" style="max-width: 20rem;border:none" class="mb-2"
            @mouseover="hover_in('SolarPowergenerationPolicy')" @mouseout="hover_out('SolarPowergenerationPolicy')"
            @click="showDoc('SolarPowergenerationPolicy1')">
            <b-icon icon="book" font-scale="3" variant="dark" class="card-icon"
              id="SolarPowergenerationPolicy"></b-icon>
            <br><b-button variant="transparent" class="link">Assam Solar Power Generation Promotion Policy
              2025</b-button>
          </b-card>
        </b-col>
        <b-col col cols="4" sm="2" md="2" lg="2">
          <input value="/docs/acts_and_rules/AssamPumpedStoragePowerGenerationPromotionPolicy2025.pdf"
            id="SolarPumpedPowergenerationPolicy1" hidden>
          <b-card title="" style="max-width: 20rem;border:none" class="mb-2"
            @mouseover="hover_in('SolarPumpedPowergenerationPolicy')"
            @mouseout="hover_out('SolarPumpedPowergenerationPolicy')"
            @click="showDoc('SolarPumpedPowergenerationPolicy1')">
            <b-icon icon="file-ruled" font-scale="3" variant="dark" class="card-icon"
              id="SolarPumpedPowergenerationPolicy"></b-icon>
            <br><b-button variant="transparent" class="link">Assam Pumped Storage Power Generation Promotion Policy
              2025</b-button>
          </b-card>
        </b-col>
         <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/RenewableEnergyPolicies">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2" @mouseover="hover_in('repo')"
              @mouseout="hover_out('repo')">
              <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="repo"></b-icon>
              <br>
              <b-button variant="transparent" class="link">Renewable Projects Related Information</b-button>
            </b-card>
          </router-link>
        </b-col>

      <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/MiscPetition">
            <b-card title="" style="max-width: 15rem;border:none" class="mb-2 " @mouseover="hover_in('to')"
              @mouseout="hover_out('to')">
              <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="to"></b-icon>
              <br><b-button variant="transparent" class="link">Miscellenous Petition</b-button>
            </b-card>
          </router-link>
        </b-col>
      </b-row>
    </b-container>

    <div>
    </div>
  </div>
</template>
<style scoped="true">
.link {

  font-size: 0.85rem;
  font-weight: 500;
  /* font-variant: small-caps; */
  padding: 0px !important;
}

.card-icon {
  transition: 1.2s;
  opacity: 0.9;
}

.card-icon-hover {
  cursor: pointer;
  transition: 1.2s;
  transform: scale(1) rotate(-360deg);
}

.mb-2 {
  padding: 0 !important;
}

@media (max-width: 768px) {
  .textAlign20px {
    margin-left: -20px;
  }

  .textAlign15px {
    margin-left: -15px;
  }

  .textAlign10px {
    margin-left: -10px;
  }
}
</style>
<script>

export default {
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    hover_in(x) {
      document.getElementById(x).classList.add("card-icon-hover");
    },
    hover_out(y) {
      document.getElementById(y).classList.remove("card-icon-hover");
    },
    showDoc(id) {
      var link = document.getElementById(id).value;
      console.log(link);
      window.open(this.$urlCommon + link);
    },
  },
  data() {
    return {

    }
  }

}

</script>
